import React from "react";


function Item({item, onClick}) {

    const handleClick = () => {
        onClick(item);
    };

    return (
        <tr className="items-table-row" onClick={handleClick}>
            <td className="item-thumb-cell">
                <img className="item-thumb" src={item.img_path ? "/api/static/img/" + item.img_path : "/api/static/landscape-placeholder.svg"} alt="" loading="lazy" />
            </td>
            <td data-label="Order number">{item.order_number || "—"}</td>
            <td data-label="Meter">{item.meter}</td>
            <td data-label="Name" className="item-name-cell">{item.name || "Unnamed item"}</td>
            <td data-label="Date">{item.date || "0"}</td>
            <td data-label="Assortiment"><span className={item.ua ? "status-pill status-pill-muted" : "status-pill status-pill-ok"}>{item.ua ? "UA" : "Active"}</span></td>
        </tr>
    );
}


function ItemsTable({items, onClick}) {
    return (
        <table className="items-table">
            <thead>
                <tr>
                    <th aria-label="Photo"></th>
                    <th>Order number</th>
                    <th>Meter</th>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Assortiment</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <Item key={index} item={item} onClick={onClick}/>
                ))}
            </tbody>
        </table>
    );
}


export default ItemsTable;
